<template >
  <div id="adminLink" class="page-wrap">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>爬虫执行情况</el-breadcrumb-item>
      <el-breadcrumb-item>监控链接实时插件</el-breadcrumb-item>
    </el-breadcrumb>
    <div>
      <el-row class="executionPage">
        <el-col :span="24">
          <div style="font-size: 18px;color: #333333;display: flex;margin-bottom: 20px;">
            <div class="iconDiv">
              .
            </div>
            监控链接今日计划监控链接数
          </div>
          <div class="fontDiv2">
            <el-col :span="24">
              <div id="planEchartsId" style="width: 90%;height: 400px;"> </div>
            </el-col>
          </div>
        </el-col>

        <el-col :span="24">
          <div style="font-size: 18px;color: #333333;display: flex;margin-bottom: 20px;">
            <div class="iconDiv">
              .
            </div>
            监控链接今日实际监控链接数
          </div>
          <div class="fontDiv2">
            <el-col :span="24">
              <div id="monitorLinklistEcharts" style="width: 90%;height: 400px;"></div>
            </el-col>
          </div>
        </el-col>

        <el-col :span="24">
          <div style="font-size: 18px;color: #333333;display: flex;margin-bottom: 20px;">
            <div class="iconDiv">
              .
            </div>
            实时查价今日各平台查询次数
          </div>
          <div class="fontDiv2">
            <el-col :span="24">
              <div id="chartProduct" style="width: 90%;height: 400px;"></div>
            </el-col>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import echarts from 'echarts'
  export default {
    data(){
      return{
        hourArr: [
          '00:00',
          '01:00',
          '02:00',
          '03:00',
          '04:00',
          '05:00',
          '06:00',
          '07:00',
          '08:00',
          '09:00',
          '10:00',
          '11:00',
          '12:00',
          '13:00',
          '14:00',
          '15:00',
          '16:00',
          '17:00',
          '18:00',
          '19:00',
          '20:00',
          '21:00',
          '22:00',
          '23:00',
        ],
      }
    },
    mounted() {
      this.productcheckcount()
      this.adminMonitorLinklist()
      this.adminMonitorLinklistplan()
    },
    methods:{
      // 实时查价今日各平台查询次数
      productcheckcount() {
        fetch({
          url: "hcm/hcmproductcheckprice/productcheckcount",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            let productData = []
            if (res.data && res.data.length != 0) {
              for (let a in res.data) {
                productData.push(res.data[a].productidcount)
              }
            }
            console.log(productData)
            this.productEcharts(productData)
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 实时查价今日各平台查询次数echarts
      productEcharts(productData) {
        this.chartLine = echarts.init(document.getElementById('chartProduct'));
        // 指定图表的配置项和数据
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data:['查询次数']
          },
          color: ['#1890ff'],
          xAxis: {
            type: 'category',
            data: ['淘宝天猫','京东','苏宁','1688','当当'],
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '查询次数',
              data:  productData,
              type: 'bar',
              barWidth : 30,
            },
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        this.chartLine.setOption(option);
      },
      // 监控链接今日实际监控链接数
      adminMonitorLinklist() {
        fetch({
          url: "hcm/monitorLink/adminMonitorLinklist",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            let planTB = []
            let planTM = []
            let planJD = []
            let planSN = []
            let plan1688 = []
            let planDD = []
            if (res.data && res.data.length != 0) {
              for (let a in res.data) {
                if (res.data[a].name == '天猫') {
                  planTM.push(res.data[a].data)
                } else if (res.data[a].name == '淘宝') {
                  planTB.push(res.data[a].data)
                } else if (res.data[a].name == '京东') {
                  planJD.push(res.data[a].data)
                } else if (res.data[a].name == '苏宁') {
                  planSN.push(res.data[a].data)
                } else if (res.data[a].name == '1688') {
                  plan1688.push(res.data[a].data)
                } else if (res.data[a].name == '当当') {
                  planDD.push(res.data[a].data)
                }
              }
              this.adminMonitorLinklistEcharts(planTB,planTM,planJD,planSN,plan1688,planDD)
            }
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 监控链接今日实际监控链接数Echarts
      adminMonitorLinklistEcharts(planTB,planTM,planJD,planSN,plan1688,planDD) {
        this.chartLine3 = echarts.init(document.getElementById('monitorLinklistEcharts'));
        // 指定图表的配置项和数据
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data:['淘宝','天猫','京东','苏宁','1688','当当']
          },
          color: ['#1890ff','#2fc25b','#facc14','#223273','#8543e0','#13c2c2'],
          xAxis: {
            type: 'category',
            data: this.hourArr,
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '淘宝',
              data:  planTB[0],
              type: 'bar',
              stack: '同',
            },{
              name: '天猫',
              data:  planTM[0],
              type: 'bar',
              stack: '同',
            },{
              name: '京东',
              data:  planJD[0],
              type: 'bar',
              stack: '同',
            },{
              name: '苏宁',
              data:  planSN[0],
              type: 'bar',
              stack: '同',
            },{
              name: '1688',
              data:  plan1688[0],
              type: 'bar',
              stack: '同',
            },{
              name: '当当',
              data:  planDD[0],
              type: 'bar',
              stack: '同',
            }
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        this.chartLine3.setOption(option);
      },
      // 监控链接今日计划监控链接数
      adminMonitorLinklistplan() {
        fetch({
          url: "hcm/monitorLink/adminMonitorLinklistplan",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            let planTB = []
            let planTM = []
            let planJD = []
            let planSN = []
            let plan1688 = []
            let planDD = []
            if (res.data && res.data.length != 0) {
              for (let a in res.data) {
                if (res.data[a].name == '天猫') {
                  planTM.push(res.data[a].data)
                } else if (res.data[a].name == '淘宝') {
                  planTB.push(res.data[a].data)
                } else if (res.data[a].name == '京东') {
                  planJD.push(res.data[a].data)
                } else if (res.data[a].name == '苏宁') {
                  planSN.push(res.data[a].data)
                } else if (res.data[a].name == '1688') {
                  plan1688.push(res.data[a].data)
                } else if (res.data[a].name == '当当') {
                  planDD.push(res.data[a].data)
                }
              }
              this.planEcharts(planTB,planTM,planJD,planSN,plan1688,planDD)
            }
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 监控链接今日计划监控链接数Echarts
      planEcharts(planTB,planTM,planJD,planSN,plan1688,planDD) {
        this.chartLine2 = echarts.init(document.getElementById('planEchartsId'));
        // 指定图表的配置项和数据
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data:['淘宝','天猫','京东','苏宁','1688','当当']
          },
          color: ['#1890ff','#2fc25b','#facc14','#223273','#8543e0','#13c2c2'],
          xAxis: {
            type: 'category',
            data: this.hourArr,
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '淘宝',
              data:  planTB[0],
              type: 'bar',
              stack: '同',
            },{
              name: '天猫',
              data:  planTM[0],
              type: 'bar',
              stack: '同',
            },{
              name: '京东',
              data:  planJD[0],
              type: 'bar',
              stack: '同',
            },{
              name: '苏宁',
              data:  planSN[0],
              type: 'bar',
              stack: '同',
            },{
              name: '1688',
              data:  plan1688[0],
              type: 'bar',
              stack: '同',
            },{
              name: '当当',
              data:  planDD[0],
              type: 'bar',
              stack: '同',
            }
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        this.chartLine2.setOption(option);
      },
    }
  }
</script>

<style lang="scss">
  #adminLink{
    .executionPage {
      margin: 20px;
      .iconDiv {
        width: 5px;
        background-color: #333333;
        margin-right: 10px;
        height: 21px;
        margin-top: 4px;
      }
      .fontDiv2 {
        padding: 20px;
        background-color: white;
        font-size: 14px;
        border-radius: 8px;
        margin-right: 20px;
        height: 360px;
        margin-bottom: 20px;
      }
    }
  }
</style>
